// src/components/ProductCard.jsx
import React from "react";
import { Link } from "react-router-dom";

const ProductCard = ({ product, currency }) => {
  const {
    id,
    name,
    description = "",
    price,
    category,
    image,
    currency: productCurrency,
    priceINR,
    displayPrice,
    displayCurrency,
    baseCurrency = "INR",
  } = product;

  const activeCurrency =
    displayCurrency || productCurrency || currency || "USD";

  const effectivePrice =
    typeof displayPrice === "number" && !Number.isNaN(displayPrice)
      ? displayPrice
      : price;

  const formatPrice = (value, currencyCode) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode || "USD",
      maximumFractionDigits: 2,
    }).format(Number(value || 0));
  };

  const maxLength = 95;
  const truncatedDescription =
    description && description.length > maxLength
      ? description.slice(0, maxLength).trim() + "…"
      : description;

  const showBaseNote =
    baseCurrency &&
    activeCurrency &&
    baseCurrency !== activeCurrency &&
    (priceINR || price);

  return (
    <Link to={`/products/${id}`} className="block h-full group">
      <article
        className="
          relative
          h-full
          overflow-hidden
          rounded-[2rem]
          border
          border-[#8b5e3c]/15
          bg-[#fffaf5]
          shadow-[0_25px_70px_rgba(74,44,23,0.10)]
          transition-all
          duration-500
          hover:-translate-y-2
          hover:shadow-[0_40px_100px_rgba(74,44,23,0.18)]
        "
      >
        {/* Soft luxury glow */}
        <div className="absolute -top-24 -right-24 h-48 w-48 rounded-full bg-[#d8bfae]/35 blur-3xl" />
        <div className="absolute -bottom-28 -left-20 h-56 w-56 rounded-full bg-[#f1d8c8]/50 blur-3xl" />

        {/* Image Area */}
        {/* Image Area */}
<div
  className="
    relative
    overflow-hidden
    rounded-t-[2rem]
    bg-[#f6efe8]
    h-[430px]
    sm:h-[520px]
  "
>
  {image ? (
    <img
      src={image}
      alt={name}
      className="
        absolute
        inset-0
        h-full
        w-full
        object-cover
        object-center
        transition-transform
        duration-700
        ease-out
        group-hover:scale-110
      "
    />
  ) : (
    <div className="flex h-full w-full items-center justify-center text-[#6B4226]/50">
      No Image
    </div>
  )}

  <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#2b160b]/25 via-transparent to-white/10" />

  <div
    className="
      absolute
      left-5
      top-5
      rounded-full
      border
      border-white/50
      bg-white/70
      px-4
      py-1.5
      text-[10px]
      uppercase
      tracking-[0.25em]
      text-[#4a2c17]
      backdrop-blur-md
    "
  >
    {category}
  </div>
</div>

        {/* Product Content */}
        <div className="relative z-10 p-5 sm:p-6">
          <div className="mb-3 flex items-start justify-between gap-4">
            <div>
              <p className="mb-2 text-[11px] uppercase tracking-[0.28em] text-[#8b5e3c]/70">
                Shahu Mumbai
              </p>

              <h3
                className="
                  text-2xl
                  sm:text-3xl
                  font-semibold
                  tracking-wide
                  text-[#3b2415]
                  leading-tight
                "
              >
                {name}
              </h3>
            </div>

            <p className="whitespace-nowrap text-lg font-semibold text-[#4a2c17]">
              {formatPrice(effectivePrice, activeCurrency)}
            </p>
          </div>

          {truncatedDescription && (
            <p className="min-h-[52px] text-sm leading-relaxed text-[#4a2c17]/70">
              {truncatedDescription}
            </p>
          )}

          {showBaseNote && (
            <p className="mt-3 text-xs text-[#4a2c17]/50">
              Approx. {formatPrice(priceINR ?? price, baseCurrency)} charged in{" "}
              {baseCurrency}
            </p>
          )}

          <div className="mt-6 flex items-center justify-between border-t border-[#8b5e3c]/10 pt-4">
            <span className="text-sm italic text-[#8b5e3c]/70">
              View details
            </span>

            <span
              className="
                flex
                h-10
                w-10
                items-center
                justify-center
                rounded-full
                bg-[#3b2415]
                text-white
                transition-all
                duration-500
                group-hover:translate-x-1
                group-hover:bg-[#8b5e3c]
              "
            >
              →
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default ProductCard;